/**
 * mapping-schema.ts — ตั้งค่า mapping ที่แก้ได้โดยไม่ deploy (CONTEXT §5.9, T098)
 *
 * - pnl_mappings: ผูก fee code / tax type / หมวดย่อย / SKU / ช่องทาง → หัวข้อ P&L
 * - source_column_mappings: template คอลัมน์ไฟล์ต่อ source/ร้าน (ใช้ซ้ำตอนนำเข้า)
 */
import { z } from 'zod';
import { uuid } from './schemas.js';
import { PNL_LINE_LABELS } from './pnl.js';

export const pnlMappingSourceKind = z.enum([
  'fee_code',
  'tax_type',
  'subcategory',
  'sku',
  'channel',
]);
export type PnlMappingSourceKind = z.infer<typeof pnlMappingSourceKind>;

export const pnlMappingInput = z.object({
  sourceKind: pnlMappingSourceKind,
  sourceValue: z.string().trim().min(1, 'กรอกค่าจากต้นทาง').max(200),
  pnlCategory: z.string().trim().min(1, 'เลือกหัวข้อ P&L').max(120),
});
export type PnlMappingInput = z.infer<typeof pnlMappingInput>;

export const sourceColumnMappingInput = z.object({
  source: z.enum(['csv', 'xlsx', 'manual', 'tiktok_api', 'shopee_api', 'lazada_api']),
  shopId: uuid.optional(),
  templateName: z.string().trim().min(1, 'ตั้งชื่อ template').max(120),
  /** { "ชื่อคอลัมน์ในไฟล์": "target field" } */
  columnMap: z.record(z.string(), z.string()),
});
export type SourceColumnMappingInput = z.infer<typeof sourceColumnMappingInput>;

/** หัวข้อ P&L ที่เลือกได้ (เฉพาะบรรทัดที่เป็นรายได้/ค่าใช้จ่าย ไม่ใช่ยอดรวม/เปอร์เซ็นต์) */
export const MAPPABLE_PNL_CATEGORIES: { key: string; label: string }[] = [
  'sales',
  'other_income',
  'cost_of_products',
  'marketing_expenses',
  'commissions_platform_fees',
  'transportation_fulfillment',
  'payroll_employee',
  'accounting_professional',
  'fixed_cost',
  'variable_cost',
  'other_operating',
  'depreciation_amortization',
  'interest_finance',
  'corporate_income_tax',
].map((key) => ({ key, label: PNL_LINE_LABELS[key as keyof typeof PNL_LINE_LABELS] ?? key }));
